import * as types from './constants';

export function setSelectedCountry(country) {
  return { type: types.SET_SELECTED_COUNTRY, country };
}
